module.exports = __webpack_public_path__ + "static/img/dCT2.4e21dc6d.png";